import React, {Component} from 'react'
import BgPhoto from '../images/bgphoto.jpg'
import Taiwan from '../images/taiwan.png'

const Jeyu = {
  banner: {
   background: 'url('+BgPhoto+')',
   backgroundSize: 'cover',
   backgroundAttachment: 'fixed',
   backgroundPosition: 'center center',
   backgroundRepeat: 'no-repeat',
   alignItems: 'center',
   display: 'flex',
   height: '84vh',
   width: '100%'
  },
  contentpadding: {
   padding: '0px 10px'
  },
  h1: {
   fontSize: 40,
   margin: 0
  },
  h2: {
   fontSize: 25,
   color: '#014852',
   fontWeight: '500',
   textAlign: 'center'
  },
  p: {
   fontSize: 20,
   lineHeight: '33px'
  },
  import: {
   color: 'rgb(255, 171, 18)',
   margin: '0 3px',
   position: 'relative'
 },
 taiwan: {
   backgroundImage: 'url('+Taiwan+')',
   backgroundSize: 'contain',
   backgroundRepeat: 'no-repeat',
   width: 15,
   height: 26,
   display: 'inline-block',
   position: 'absolute',
   left: 140
 }
}

export default class Banner extends Component {
  render() {
    return(
      <div style={Jeyu.banner} className="banner fixed">
       <div className="container">
        <div className="row">
         <div style={Jeyu.contentpadding}>
          <h2 style={Jeyu.h1} className="mobileh1">符合世界衛生組織<span style={Jeyu.arial}>(WHO)</span>標準</h2>
          <h1 style={Jeyu.h1} className="mobileh1">長效型機能纖維紗<strong style={Jeyu.hcolor}>有效消滅病媒蚊</strong></h1>
          <p style={Jeyu.p} className="mobilep">本公司取得獨家技術製程，採用奈米技術，將<span style={Jeyu.import}>氯菊酯/除蟲菊</span>嵌入原料之中，<br />一旦害蟲接觸到<span style={Jeyu.import}>JeyuTex除蟲系列布料</span>，其神經系統將受干擾損壞，<br />進而喪失行動能力。<br />
          本產品通過SDS化學品安全檢測，不會對人體造成傷害，可安心使用。</p>
          <p style={Jeyu.import}>來自台灣 品質保證<span style={Jeyu.taiwan}></span></p>
         </div>
        </div>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/Banner.js